import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import SettingPage from './SettingPage';
// import './SettingPage.less';

export const prefix = 'bm-p-setting';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: SettingPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
